export const GENERAL_ERROR_MESSAGE = 'Something went wrong';

export const TASK_CARD_HEIGHT = 300;

export const PRIORITY_SERVICE_CATEGORIES = ['Removals', 'Packing & Unpacking', 'Cleaning', 'Handyman', 'Locksmith'];
